import getApi from '../../api'

export const readNotifications = (notificationIds: Array<String>) => {
  return getApi().post<null>(`/notifications/read/batch`, { notifications: notificationIds })
}
